import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";

// import store from '../../store.jsVue.use(VueAxios, axios);
Vue.use(VueAxios, axios);
Vue.axios.defaults.baseURL = process.env.VUE_APP_API_BASE || "/";

const API_URL = process.env.VUE_APP_API_ROOT || "/api/v1";

const securedAxiosInstance = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json"
  }
});

const plainAxiosInstance = axios.create({
  baseURL: API_URL,
  // withCredentials: true,
  headers: {
    "Content-Type": "application/json"
  }
});

plainAxiosInstance.interceptors.request.use(config => {
  const method = config.method.toUpperCase();
  config.headers = {
    ...config.headers,
    "Content-Type": "application/json",
    "token-type": localStorage.default_auth_token
      ? localStorage.default_auth_token.split(";")[0]
      : null,
    "access-token": localStorage.default_auth_token
      ? localStorage.default_auth_token.split(";")[1]
      : null,
    client: localStorage.default_auth_token
      ? localStorage.default_auth_token.split(";")[2]
      : null,
    uid: localStorage.default_auth_token
      ? localStorage.default_auth_token.split(";")[3]
      : null,
    expiry: localStorage.default_auth_token
      ? localStorage.default_auth_token.split(";")[4]
      : null
  };
  return config;
});

plainAxiosInstance.interceptors.response.use(
  function(response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    // console.log(response);
    if (response.headers["access-token"]) {
      let token = [
        response.headers["token-type"],
        response.headers["access-token"],
        response.headers["client"],
        response.headers["uid"],
        response.headers["expiry"]
      ].join(";");
      localStorage.default_auth_token = token;
    }
    return response;
  },
  function(error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error);
  }
);

export default { plainAxiosInstance };
